import { fetchWrapper } from './ApiHelper';

const API_BASE_URL = process.env.REACT_APP_BACKEND_ROOT_PM;

// Role Management

export const getUserPermissions = () =>
  fetchWrapper(`${API_BASE_URL}/api/users/permission`);
